import karmaCalling from "./karmaCalling2560x1440.png";
import karmaCalling2560x1600 from "./karmaCalling2560x1600.png";
import karmaCalling1600x1200 from "./karmaCalling1600x1200.png";
import karmaCalling1024x768 from "./karmaCalling1024x1292.png";
import karmaCallingMb from "./Karma_mb.png";

import guilty from "./guilty2560x1440.png";
import guilty2560x1600 from "./guilty2560x1600.png";
import guilty1600x1200 from "./guilty1600x1200.png";
import guilty1024x1292 from "./guilty1024x1292.png";
import guiltyMb from "./Guilty_mb.png";

import hundred from "./hundred2560x1440.png";
import hundred2560x1600 from "./hundred2560x1600.png";
import hundred1600x1200 from "./hundred1600x1200.png";
import hundred1024x1292 from "./hundred1024x1292.png";
import hundredMb from "./Hundred_mb.png";

import hanuman from "./hanuman2560x1440.png";
import hanuman2560x1600 from "./hanuman2560x1600.png";
import hanuman1600x1200 from "./hanuman1600x1200.png";
import hanuman1024x1292 from "./hanuman1024x1292.png";

import hanumanMb from "./Hanuman_mb.png";

// import kal from "./Kal2560n.png";
// import kal1280 from "./kalnn.png";
import kal from "./kal2560x1440.png";
import kal2560x1600 from "./kal2560x1600.png";
import kal1600x1200 from "./kal1600x1200.png";
import kal1024x1292 from "./kal1024x1292.png";
import kalMb from "./Kal_mb.png";

export const longFormatAssets = {
  karmaCalling,
  karmaCalling2560x1600,
  karmaCalling1600x1200,
  karmaCalling1024x768,
  karmaCallingMb,
  guilty,
  guilty2560x1600,
  guilty1600x1200,
  guilty1024x1292,
  guiltyMb,
  hundred,
  hundred2560x1600,
  hundred1600x1200,
  hundred1024x1292,
  hundredMb,
  hanuman,
  hanuman2560x1600,
  hanuman1600x1200,
  hanuman1024x1292,
  hanumanMb,
  kal,
  // kal1280,
  kal2560x1600,
  kal1600x1200,
  kal1024x1292,
  kalMb,
};
